import React, { Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import ModuleLoaderLazy from '../../redux/ModuleLoaderLazy';

/**
 * This is the global init for amsterdamn, this we trigger auth, fetching
 * of counts, and listening for damz activity events.
 */
export const DamzGlobalLoadable: React.FC<{}> = props => {
  return (
    <ErrorBoundary debugComponent="DamzGlobalLoadable">
      <Suspense fallback={null}>
        <ModuleLoaderLazy />
      </Suspense>
    </ErrorBoundary>
  );
};
DamzGlobalLoadable.displayName = 'DamzGlobalLoadable';

export default DamzGlobalLoadable;
